<div class="container">
  <div class="row">
    <div class="col-12 mb-4">

      <div class="row">
        
        <!-- Tabla Diario -->
        <app-insight-table
          [title]="'Medidor Diario'"
          [meter]="dailyMeter"
          [colSpan]="colsDaily"
          [showMeta]="false">
        </app-insight-table>

        <div class="col-12 mb-4">
          <hr>
        </div>

        <!-- Tabla Semanal -->
        <app-insight-table
          [title]="'Medidor Semanal'"
          [meter]="weeklyMeter"
          [colSpan]="colsWeekly"
          [showMeta]="true">
        </app-insight-table>

      </div>

    </div>
  </div>
</div>
